// extracted by mini-css-extract-plugin
module.exports = {"pageSectionForm":"_2zen9"};